import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-summary',
  templateUrl: './booking-summary.component.html',
  styleUrls: ['./booking-summary.component.scss']
})

export class BookingSummaryComponent implements OnInit {
  @Input() details: any;
  @Input() isRevisit: boolean = false;  // Adding input for followUp status

  ngOnInit(): void {
   
  }
  
}
